<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
         
          <!-- <a-form-item
            label="所属单位"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-input
              placeholder="请输入所属单位"
              v-decorator="[
          'idCard',
          {rules: [{ required: false, message: '请输入所属单位!' }],initialValue:info.idCard}
        ]"
            ></a-input>
          </a-form-item> -->
          <a-form-item label="报名人数" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入报名人数"
              disabled
              v-decorator="[
          'number',
          {rules: [{ required: false, message: '请输入报名人数!' }],initialValue:info.number}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="单价" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入单价"
              @change="priceChange"
              v-decorator="[
          'specialty',
          {rules: [{ required: false, message: '请输入单价!' }],initialValue:info.specialty}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="总价" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入总价"
              v-decorator="[
          'totalNum',
          {rules: [{ required: false, message: '请输入总价!' }],initialValue:info.totalNum}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="上一步" type="default" @click="cancelClick" class="cancelBtn" />
            <pxkeji-btn name="确定" type="primary" class="nextBtn" htmlType="submit" />
          </a-form-item>
        </a-form>
      </div>
      
    </div>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    },
    num: Number,
    ids: String,
    cid: String
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        number: "",
        startTime: "",
        endTime: ""
      },
      servicelists: [],
      serviceNames: [],
      serviceIds: [],
      goodlists: [],
      goodNames: [],
      goodIds: [],
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      idCardfileList: [],
      graduatefileList: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: [],
      service: {
        //服务项目
        visible: false
      },
      good: {
        //擅长项目
        visible: false
      },
      schedule: {
        //排班
        visible: false,
        list: ""
      }
    };
  },
  components: {
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      that.info.number = this.num;
      console.log(this.cid)
      if (!this.type) {
        this.dis = true;
      }
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    //性别选择
    onChange(e){
      // console.log(e.target.value)
      this.info.sex = e.target.value;
    },
    // 单价变化
    priceChange(e){
      var singalPri = e.target.value;
      this.info.totalNum = singalPri*this.num;
    },
    /**选择可服务项目 */
    choseService() {
      this.service.visible = true;
    },
    getservice(data) {
      this.service.visible = false;
      this.servicelists = [];
      this.serviceNames = [];
      this.serviceIds = [];
      data.forEach(function(item, index) {
        that.servicelists.push({
          name: item.name,
          id: item.id,
          img: item.img
        });
        that.serviceNames.push(item.name);
        that.serviceIds.push(item.id);
      });
      that.info.serviceNames = this.serviceNames.join(",");
      this.form.setFieldsValue({
        serviceNames: this.serviceNames.join(",")
      });
    },
    /**选择擅长 */
    choseGood() {
      this.good.visible = true;
    },
    getgood(data) {
      this.good.visible = false;
      this.goodlists = [];
      this.goodNames = [];
      this.goodIds = [];
      data.forEach(function(item, index) {
        that.goodlists.push({
          name: item.name,
          id: item.id
        });
        that.goodNames.push(item.name);
        that.goodIds.push(item.id);
      });
      that.info.goodNames = this.goodNames.join(",");
      this.form.setFieldsValue({
        goodNames: this.goodNames.join(",")
      });
    },
    /**查看排班 */
    handleSchedule() {
      this.schedule.visible = true;
    },
    getschedule(data) {
      this.schedule.visible = false;
      var schedules = {};
      data.forEach(function(item, index) {
        var thisData = {};
        thisData["am"] = item.am;
        thisData["pm"] = item.pm;
        schedules[item.time] = thisData;
      });
      this.schedule.list = JSON.stringify(schedules);
      //console.log(schedules);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.order
              .saveOrderByUserIds(
                this.ids,
                this.cid,
                "2",
                this.info.totalNum
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                  //this.form.resetFields();
                } else {
                  this.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
        }
      });
    },

    onRangeChange(value, dateString) {
      this.info.startTime = dateString[0];
      this.info.endTime = dateString[1];
    },
    onCheckboxChange(e) {
      this.info.checked = e.target.checked;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.scheduleBtn {
  color: #1890ff;
  cursor: pointer;
}
.nextBtn {
  margin-left: 20px;
}
</style>